import { FC, ReactElement } from "react";
import styles from "./is-device.module.scss";
import { DeviceType } from "./device-utils";
import React from "react";
import cx from "classnames";

interface INotIsDevice {
  device: DeviceType;
  children: ReactElement | ReactElement[];
  className?: string;
  condition?: boolean;
}

const DeviceStyles = {
  [DeviceType.desktop]: styles.notDesktop,
  [DeviceType.bigTablet]: styles.notBigtablet,
  [DeviceType.tablet]: styles.notTablet,
  [DeviceType.mobile]: styles.notMobile,
};

const NotIsDevice: FC<INotIsDevice> = ({
  device,
  children,
  className,
  condition,
}): ReactElement | ReactElement[] | null => {
  const deviceStyle = DeviceStyles[device];
  return condition === undefined || condition ? <div className={cx(className, deviceStyle)}>{children}</div> : null;
};

export default NotIsDevice;
